import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import '../assets/css/style.css';
import '../assets/css/style.responsive.css';
import RouteHandler from './RouteHandler';

function App() {
    return <RouteHandler />;
}

export default App;
